'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.tags.edit', [])
  .controller('TagsEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/tags/edit/index.js